import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { SessionService } from '../../session.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-reset-mail',
  templateUrl: './password-reset-mail.component.html',
  styleUrls: ['./password-reset-mail.component.css'],
  standalone: false,
})
export class PasswordResetMailComponent implements OnInit {

  admin_id?: string;

  editForm : FormGroup;
  adminIdControl!: FormControl;

  constructor(
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.editForm = this.formBuilder.group({
      admin_id: [this.admin_id, [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.adminIdControl = this.editForm.get('admin_id') as FormControl;
  }

  passwordReset(): void {
    this.sessionService.passwordResetMail(this.adminIdControl.value);
  }
  //以下、フォームの記入エラー表示
  public getErrorMessageToAdminId() {
    return this.adminIdControl.hasError('required')
    ? '必須項目'
    : this.adminIdControl.hasError('email')
    ? 'メール形式'
    : '';
  }
}
